/* eslint-disable */
export const maxLifetime = 27

export default [
[ 0, 1000 ],
[ 1, 581 ],
[ 2, 400 ],
[ 3, 305 ],
[ 4, 240 ],
[ 5, 171 ],
[ 6, 111 ],
[ 7, 66 ],
[ 8, 45 ],
[ 9, 19 ],
[ 10, 0 ]
]
